/* eslint-disable @typescript-eslint/naming-convention, sort-keys */
import { ISchemaAdditionalProperties } from '../api/JsonSchemaApi';
import { INPUT_TYPE } from './Constants';

export interface IDefaultAdditionalPropertiesSchema {
  [key: string]: {
    additionalProperties: ISchemaAdditionalProperties;
  };
}

const DEFAULT_ADDITIONAL_PROPERTIES_SCHEMA: IDefaultAdditionalPropertiesSchema = Object.freeze({
  country_id: {
    additionalProperties: {
      x: 1,
      y: 1,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  first_name: {
    additionalProperties: {
      x: 1,
      y: 2,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  last_name: {
    additionalProperties: {
      x: 2,
      y: 2,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  address1: {
    additionalProperties: {
      x: 1,
      y: 3,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  address2: {
    additionalProperties: {
      x: 2,
      y: 3,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  postal_code: {
    additionalProperties: {
      x: 1,
      y: 4,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  city: {
    additionalProperties: {
      x: 2,
      y: 4,
      input_type: INPUT_TYPE.TEXT,
    },
  },
  state: {
    additionalProperties: {
      x: 1,
      y: 5,
      input_type: INPUT_TYPE.SELECT,
    },
  },
  phone1: {
    additionalProperties: {
      x: 2,
      y: 5,
      input_type: INPUT_TYPE.TEL,
    },
  },
  delivery_instructions: {
    additionalProperties: {
      x: 1,
      y: 8,
      input_type: INPUT_TYPE.TEXTAREA,
    },
  },
});

export const CONDENSED_ADDITIONAL_PROPERTIES_SCHEMA: IDefaultAdditionalPropertiesSchema = Object
  .freeze({
    country_id: {
      additionalProperties: {
        x: 1,
        y: 1,
      },
    },
    first_name: {
      additionalProperties: {
        x: 1,
        y: 1,
        widget: 'text',
      },
    },
    last_name: {
      additionalProperties: {
        x: 2,
        y: 1,
        widget: 'text',
      },
    },
    full_name: {
      additionalProperties: {
        x: 1,
        y: 1,
        widget: 'text',
      },
    },
    postal_code: {
      additionalProperties: {
        x: 2,
        y: 1,
        widget: 'text',
      },
    },
    address1: {
      additionalProperties: {
        x: 1,
        y: 2,
        widget: 'text',
      },
    },
    address_search: {
      additionalProperties: {
        x: 1,
        y: 2,
        widget: 'text',
      },
    },
    phone1: {
      additionalProperties: {
        x: 2,
        y: 2,
        widget: 'tel',
      },
    },
  });

export default DEFAULT_ADDITIONAL_PROPERTIES_SCHEMA;
